$shm_hitalama_map_table $mol_view
	controller $mol_view
	sub / <= content $mol_view
